import { DOCUMENT } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalObjectInterface } from '@components/components/modal/modal.component';
import { CarsCustomerService } from '@customers/services/cars.customer.service';
import { PaymentCustomerService } from '@customers/services/payment.customer.service';
import { ProfileCustomerService } from '@customers/services/profile.customer.service';
import { RequestsCustomerService } from '@customers/services/requests.customer.service';
import { SharedCustomerService } from '@customers/services/shared.customer.service';
import { TranslateService } from '@ngx-translate/core';
import { CarCustomerService } from '@parts-catalog/services/cars.customer.service';
import { CartCustomerService, PremiumQuotationInterface } from '@parts-catalog/services/cart.customer.service';
import { CatalogsCustomerService } from '@parts-catalog/services/catalogs.customer.service';
import { AuthService } from '@reusable/services/auth/auth.service';
import { ContentService } from '@reusable/services/common/content.service';
import * as globals from '@reusable/services/globals';
import { S3Uploader } from '@reusable/services/helpers/uploader.service';
import { ValidateVinService, vinValidator } from '@reusable/services/validate-vin';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { Subscription } from 'rxjs';
declare let rudderanalytics: any;

@Component({
  selector: 'store-new-request',
  standalone: false,
  templateUrl: './new-request.component.html',
  styleUrls: ['./new-request.component.scss']

})
export class StoreNewRequestComponent implements OnInit {
  @Input() modelId: any;
  @Input() homePage: boolean;
  @Input() manufactureId: any;
  uploadingPhoto: boolean;
  isAuthenticated: boolean = false;
  modelIdBindValue = 'internalModelId';
  requestSent: ModalObjectInterface = {
    style: 'light --absoluted medium',
    type: 'default',
    open: false
  };
  hyperpay: any | null;
  requestTypes = [
    { id: 'new', label: 'قطع غيار جديدة' },
    { id: 'used', label: 'قطع غيار تشليح' }
  ];
  steps = [
    {
      title: 'نوع الطلب',
      description: '',
      active: true
    },
    {
      title: 'مواصفات السيارة',
      description: '',
      active: false
    },
    {
      title: 'القطع المطلوبة',
      description: '',
      active: false
    },
    {
      title: 'تسجيل الدخول',
      description: '',
      active: false,
      hidden: false
    },
    {
      title: 'ملخص الطلب',
      description: '',
      active: false
    },

    {
      title: 'الدفع',
      description: '',
      active: false
    }
  ];

  partFormGroup = new UntypedFormGroup({
    name: new UntypedFormControl('', {
      validators: Validators.required
    }),
    quantity: new UntypedFormControl(1, {
      validators: Validators.required
    }),
    photo: new UntypedFormControl('')
  });

  createRequestFormGroup = this.fb.group({
    partType: new UntypedFormControl('', {
      validators: Validators.required
    }),
    carId: new UntypedFormControl(''),
    manufactureId: new UntypedFormControl('', {
      validators: Validators.required,
      updateOn: 'blur'
    }),
    modelId: new UntypedFormControl('', {
      validators: Validators.required,
      updateOn: 'blur'
    }),
    modelYear: new UntypedFormControl('', {
      validators: Validators.required,
      updateOn: 'blur'
    }),
    vinNumber: new UntypedFormControl('', [Validators.required, vinValidator(this.vvs)]),
    discountCode: new UntypedFormControl(''),
    parts: new UntypedFormArray([this.partFormGroup]),
    engine: new UntypedFormControl(''),
    engine_capacity: new UntypedFormControl(''),
    engine_type: new UntypedFormControl(''),
    grade: new UntypedFormControl(''),
    sales_region: new UntypedFormControl(''),
    trans_type: new UntypedFormControl(''),
    fuel_type: new UntypedFormControl('')
  });
  queryOptions: any = {
    sortBy: 'order',
    records: null,
    pageNumber: 1
  };

  selected = {
    car: null,
    manifactor: null,
    model: null,
    year: null
  };

  yearItem = globals.generateYear();
  catalogYears = [];
  partTypes = [
    { id: 'original', label: 'أصلي', checked: true },
    { id: 'replacement', label: 'بديل', checked: false },
    { id: 'used', label: 'مستعمل', checked: true }
  ];
  modItems: any;
  modelItems = [];
  myCarId: string;
  myCarObject: any;
  userCarsList = [];
  userCarsItems = [];
  manifictureItems = [];
  currentStep: number = 0;

  method: any;
  userId: any;
  request: any;
  paytabs: string;
  payLabel: string;
  userProfile: any;
  selectedMada: boolean;
  selectedCredit: boolean;
  vinNumberAdded: boolean;
  openSelectCarDp: boolean;
  openSelectYearDp: boolean;
  isSending: boolean = false;
  openManifactureDp: boolean;
  selectedTransaction: boolean;
  debitedBank: Array<any> = [];
  selectedBankItem: any[] = [];
  selectedWallet: boolean;
  selectedCar: any = {
    publishCatalog: null
  };
  modelList: any;
  userEmail: any;
  targetCar: any;
  userWallet: any;
  subscribtion: any;
  codeResponse: any;
  _homePage: boolean;
  userAction: string;
  isVerifing: boolean;
  togglePopup = false;
  _selectedModel: any;
  carInformation: any;
  userSelectedCar: any;
  loadingCatalog = false;
  dataLoading: boolean;
  updateEmail: string = '';
  dontOpenDropBox: boolean;
  selectedHyperpay: boolean;
  querParams$: Subscription;
  Subscription: Subscription;
  premiumAmount: number = 10;
  partsList: Observable<any>;
  loadingCatalogData: boolean;
  vinLoading: boolean = false;
  searchInput$ = new BehaviorSubject<string>(null);
  validVINEnteredForCatalog: boolean = false;
  vinLabel: string = 'تصفح قطع غيار سيارتك';
  emailRegEx = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
  partsListArray: any[] = [];
  selectedPartsList: any = [];
  validQuotation: boolean = false;
  haveParameters: any;
  parameters = {
    engine: '',
    engine_capacity: '',
    engine_type: '',
    grade: '',
    sales_region: '',
    trans_type: '',
    fuel_type: ''
  };
  matchingCarsCount: any;

  constructor(
    private title: Title,
    private router: Router,
    private fb: UntypedFormBuilder,
    private auth: AuthService,
    private cs: ContentService,
    private toastr: ToastrService,
    private s3Uploader: S3Uploader,
    private sanitizer: DomSanitizer,
    private ccss: CarCustomerService,
    private cdref: ChangeDetectorRef,
    private vvs: ValidateVinService,
    private ccs: CarsCustomerService,
    private scs: SharedCustomerService,
    private translate: TranslateService,
    private crs: RequestsCustomerService,
    private activatedRoute: ActivatedRoute,
    public cartService: CartCustomerService,
    @Inject(DOCUMENT) private document: any,
    private profileService: ProfileCustomerService,
    private paymentService: PaymentCustomerService,
    private catalogCustomerService: CatalogsCustomerService
  ) {
    this.translate.use('ar');
    title.setTitle('سبيرو - اضافة طلب');
  }

  ngOnInit() {
    if (this.homePage) {
      this._homePage = this.homePage;
      this.currentStep = 0;
      this.scs.updateAnalytics('first_open');
    } else {
      this.currentStep = 1;
    }
    this.getCoreCars();
    this.getUserWallet();
    this.listUserCars();
    if (this.querParams$) {
      this.querParams$.unsubscribe();
    }
    this.querParams$ = this.activatedRoute.queryParams.subscribe((data: any) => {
      if (data?.vinNumber && data.vinNumber.length >= 10 && data.vinNumber.length <= 17) {
        this.createRequestFormGroup.get('vinNumber').setValue(data.vinNumber);
        this.createRequestFormGroup.get('vinNumber').updateValueAndValidity();
      }
    });
    this.isAuthenticated = this.auth.isLoggedIn();
    this.createRequestFormGroup.valueChanges.subscribe((v: any) => {
      if (v?.partType) {
        if (v.partType.id === 'new') {
          this.partTypes = [
            { id: 'original', label: 'أصلي', checked: true },
            { id: 'replacement', label: 'بديل', checked: false }
          ];
          if (this.createRequestFormGroup.get('manufactureId')?.value) {
            const manufacture = this.createRequestFormGroup.get('manufactureId').value;
            const selectedManif = this.manifictureItems.find(item => item._id === manufacture);
            this.premiumAmount = selectedManif?.premiumAmountPerNewPart;
          }
        } else {
          this.partTypes = [{ id: 'used', label: 'مستعمل', checked: true }];
          if (this.createRequestFormGroup.get('manufactureId')?.value) {
            const manufacture = this.createRequestFormGroup.get('manufactureId').value;
            const selectedManif = this.manifictureItems.find(item => item._id === manufacture);
            this.premiumAmount = selectedManif?.premiumAmountPerUsedPart;
          }
        }
      }
      const selectedCar = this.userCarsList.length && this.userCarsList.find(c => c._id === this.myCarId);
      if (v?.vinNumber) {
        if (selectedCar) {
          this.vinNumberAdded = true;
        }
      } else if (v && !v.vinNumber) {
        this.vinNumberAdded = false;
      }
    });
  }

  togglePartType(type) {
    this.createRequestFormGroup.get('partType').setValue(type);
    if (type && type.id === 'new') {
      this.checkVinValidation();
      return;
    }
    this.validVINEnteredForCatalog = false;
    this.vinLabel = 'اختر  مواصفات السيارة';
    if (this.targetCar) {
      this.createRequestFormGroup.get('manufactureId').setValue(this.targetCar.manufactureId);
      this.manufChanged(this.targetCar.manufactureId);
    }
  }

  checkVinValidation(carId?) {
    let vinNumber;
    const selectedCar = this.userCarsList?.length && this.userCarsList.find(c => c._id === this.myCarId || carId);
    if (selectedCar?.manufactureId?.vinNumber) {
      vinNumber = selectedCar.vinNumber;
    } else {
      vinNumber = this.createRequestFormGroup.get('vinNumber').value;
      if (!this.createRequestFormGroup.get('vinNumber').valid) {
        return;
      }
    }
    if (!vinNumber) {
      return;
    }
    this.vinLabel = 'جاري التحقق من رقم الهيكل...';
    this.vinLoading = true;
    if (this.Subscription) {
      this.Subscription.unsubscribe();
    }
    this.haveParameters = null;
    this.parameters = {
      engine: '',
      engine_capacity: '',
      engine_type: '',
      grade: '',
      sales_region: '',
      trans_type: '',
      fuel_type: ''
    };

    this.Subscription = this.catalogCustomerService.searchByVinForCustomerForm(vinNumber).subscribe(
      (response:any) => {
        this.vinLoading = false;
        if (response.case === 1) {
          this.dontOpenDropBox = true;
          const { car, partsCatalogsCar, parameters } = response;
          this.carInformation = {
            modelName: `${partsCatalogsCar.brand} ${partsCatalogsCar.title}`,
            internalModelId: car.modelId,
            manufactureId: car.manufactureId,
            modelId: car.modelId,
            modelYear: car.modelYear,
            publishCatalog: car.publishCatalog,
            criteria: partsCatalogsCar.criteria,
            vinNumber,
            carInfo: `${partsCatalogsCar.brand} ${partsCatalogsCar.title}`,
            catalogId: partsCatalogsCar.catalogId,
            carName: partsCatalogsCar.title,
            carId: partsCatalogsCar.carId,
            title: partsCatalogsCar.title,
            year: this.getValueFromParameters(partsCatalogsCar.parameters, 'year'),
            model: this.getValueFromParameters(partsCatalogsCar.parameters, 'model'),
            engine: this.getValueFromParameters(partsCatalogsCar.parameters, 'engine'),
            transmission: this.getValueFromParameters(partsCatalogsCar.parameters, 'transmission'),
            region: this.getValueFromParameters(partsCatalogsCar.parameters, 'region')
          };
          this.targetCar = this.carInformation;
          this.haveParameters = parameters;
          this.matchingCarsCount = response.matchingCarsCount;
          for (const prop in parameters) {
            if (parameters.hasOwnProperty(prop)) {
              this.parameters[prop] = parameters[prop].map(p => ({ id: p, label: p }));
              if (this.matchingCarsCount === 1) {
                this.createRequestFormGroup.get('engine').setValue(parameters?.engine?.length ? parameters.engine[0] : null);
                this.createRequestFormGroup.get('engine').updateValueAndValidity();

                this.createRequestFormGroup.get('engine_capacity').setValue(parameters?.engine_capacity?.length ? parameters.engine_capacity[0] : null);
                this.createRequestFormGroup.get('engine_capacity').updateValueAndValidity();

                this.createRequestFormGroup.get('engine_type').setValue(parameters?.engine_type?.length ? parameters.engine_type[0] : null);
                this.createRequestFormGroup.get('engine_type').updateValueAndValidity();

                this.createRequestFormGroup.get('grade').setValue(parameters?.grade?.length ? parameters.grade[0] : null);
                this.createRequestFormGroup.get('grade').updateValueAndValidity();

                this.createRequestFormGroup.get('sales_region').setValue(parameters?.sales_region?.length ? parameters.sales_region[0] : null);
                this.createRequestFormGroup.get('sales_region').updateValueAndValidity();

                this.createRequestFormGroup.get('trans_type').setValue(parameters?.trans_type?.length ? parameters.trans_type[0] : null);
                this.createRequestFormGroup.get('trans_type').updateValueAndValidity();

                this.createRequestFormGroup.get('fuel_type').setValue(parameters?.fuel_type?.length ? parameters.fuel_type[0] : null);
                this.createRequestFormGroup.get('fuel_type').updateValueAndValidity();
              }
            }
          }
          this.manufChanged(this.targetCar.manufactureId);
          this.createRequestFormGroup.get('manufactureId').setValue(this.targetCar.manufactureId);
          const partType = this.createRequestFormGroup.get('partType').value.id;
          if (this.targetCar.publishCatalog && partType === 'new') {
            this.vinLabel = 'تصفح قطع غيار سيارتك';
            this.validVINEnteredForCatalog = true;
          } else {
            this.validVINEnteredForCatalog = false;
            this.vinLabel = 'اختر  مواصفات السيارة';
          }
        } else {
          this.validVINEnteredForCatalog = false;
          this.carInformation = null;
          this.targetCar = null;
          this.createRequestFormGroup.get('manufactureId').reset();
          this.createRequestFormGroup.get('modelId').reset();
          this.createRequestFormGroup.get('modelYear').reset();
          this.loadingCatalogData = false;
        }
        return null;
      },
      err => {
        this.vinLabel = 'تصفح قطع غيار سيارتك';
        this.vinLoading = false;
      }
    );
  }

  getValueFromParameters(parameter: any[], key: string): string {
    let value;
    parameter.forEach(element => {
      if (element.name.toLocaleLowerCase() === key) {
        value = element.value;
      }
    });
    return value;
  }

  selectingCarFromList(e) {
    this.createRequestFormGroup.get('vinNumber').reset();
    this.userSelectedCar = this.userCarsList.find(c => c._id === e);
    if (this.userSelectedCar) {
      if (this.userSelectedCar.manufactureId.publishCatalog) {
        this.checkVinValidation(e);
      }
      this.manufChanged(this.userSelectedCar.manufactureId._id);
      this.vinNumberAdded = true;
      this.createRequestFormGroup.get('vinNumber').setValue(this.userSelectedCar.vinNumber);
      this.createRequestFormGroup.get('vinNumber').updateValueAndValidity();
    }
  }

  getUserProfile() {
    this.profileService.userProfile().subscribe((profile: any) => {
      if (profile.case === 1) {
        this.userProfile = profile.user;
        this.userEmail = this.userProfile.email;
        if (this.userProfile && this.userProfile.totalPaid < 15000) {
          this.steps = [
            {
              title: 'نوع الطلب',
              description: '',
              active: true
            },
            {
              title: 'مواصفات السيارة',
              description: '',
              active: true
            },
            {
              title: 'القطع المطلوبة',
              description: '',
              active: true
            },
            {
              title: 'تسجيل الدخول',
              description: '',
              active: true
            },
            {
              title: 'ملخص الطلب',
              description: '',
              active: true
            },
            {
              title: 'اتمام الدفع',
              description: '',
              active: false
            },
            {
              title: 'أرسل الطلب',
              description: '',
              active: false
            }
          ];
        } else {
          this.steps = [
            {
              title: 'نوع الطلب',
              description: '',
              active: true
            },
            {
              title: 'مواصفات السيارة',
              description: '',
              active: true
            },
            {
              title: 'القطع المطلوبة',
              description: '',
              active: true
            },
            {
              title: 'تسجيل الدخول',
              description: '',
              active: true
            },
            {
              title: 'ملخص الطلب',
              description: '',
              active: true
            },
            {
              title: 'أرسل الطلب',
              description: '',
              active: false
            }
          ];
        }
      }
    });
  }

  partPricingFee() {
    if (this.createRequestFormGroup.get('partType').value.id === 'new') {
      return this.selectedCar?.premiumAmountPerNewPart;
    } else {
      return this.selectedCar?.premiumAmountPerUsedPart;
    }
  }

  totalPricingFee() {
    const partsArray = this.createRequestFormGroup.get('parts') as UntypedFormArray;
    if (partsArray?.value?.length) {
      let count: number = 0;
      partsArray.value.map(part => {
        if (this.createRequestFormGroup.get('partType').value.id === 'new') {
          count += this.selectedCar?.premiumAmountPerNewPart;
        } else {
          count += this.selectedCar?.premiumAmountPerUsedPart;
        }
      });
      return count;
    }
  }

  async manufChanged(value, car = null) {
    const selectedManif = await this.manifictureItems.find(item => item._id === value);
    let modelYear = '';

    if (selectedManif) {
      if (!this.dontOpenDropBox) {
        this.openSelectCarDp = true;
      }

      this.loadingCatalogData = true;
      if (car) {
        await this.createRequestFormGroup.get('manufactureId').setValue(car.resp.modelId.manufactureId._id);
        modelYear = car.resp.modelYear;
      }

      if (!this.selectedCar.publishCatalog) {
        this.setModelyear(Number(modelYear));
      }

      this.selectedCar = {
        _id: selectedManif._id,
        nameEnglish: selectedManif.nameEnglish,
        publishCatalog: selectedManif.publishCatalog,
        premiumAmountPerNewPart: selectedManif.premiumAmountPerNewPart,
        premiumAmountPerUsedPart: selectedManif.premiumAmountPerUsedPart,
        modelYear
      };

      this.selected.manifactor = selectedManif;

      await this.ccss.listModels('order', '100', 1, { catalogId: selectedManif.nameEnglish.toLowerCase() }).subscribe((response: any) => {
        if (response) {
          if (response.case === 1) {
            this.modelList = response.models;
            this.loadingCatalogData = false;
          }
          if (selectedManif.publishCatalog) {
            this.modelIdBindValue = 'internalModelId';
            if (response.case === 1) {
              this.modelItems = response.models.map(model => ({
                _id: model._id,
                nameArabic: model?.arabicName ? model.arabicName : null,
                internalModelId: model.internalModelId
              }));
            }
          } else {
            this.modelIdBindValue = '_id';
            this.modelItems = selectedManif.modelsIds;
            this.loadingCatalogData = false;
          }
          if (car) {
            this.createRequestFormGroup.get('modelId').setValue(car.resp.modelId._id);
          }
          if (this.modelId) {
            this.createRequestFormGroup.get('modelId').setValue(this.modelId);
          }
          if (this.targetCar?.internalModelId) {
            this.createRequestFormGroup.get('modelId').setValue(this.targetCar.internalModelId);
          }
          if (this.targetCar?.modelYear) {
            this.createRequestFormGroup.get('modelYear').setValue(Number(this.targetCar.modelYear));
          }
          if (this.targetCar?.publishCatalog) {
            this.loadingCatalogData = false;
          }
        }
      });
    }
  }

  selectedModel(e) {
    if (!e) {
      return;
    }

    this._selectedModel = e;
    if (!this.dontOpenDropBox) {
      this.openSelectYearDp = true;
    }
    if (this.modelList?.length) {
      this.modelList.map(model => {
        if (model[this.modelIdBindValue] === e) {
          this._selectedModel = model;
        }
      });
    }
    this.loadCatalogModelYears();
  }

  handleClickOnDisabledDp(dropBoxType) {
    switch (dropBoxType) {
      case 'carSelectDb':
        if (!this.createRequestFormGroup.get('manufactureId').value) {
          this.openManifactureDp = true;
        }
        break;
      case 'yearSelectDb':
        if (!this.createRequestFormGroup.get('manufactureId').value) {
          this.openManifactureDp = true;
        }
        if (!this.createRequestFormGroup.get('modelId').value) {
          this.openManifactureDp = true;
        }
    }
  }

  resetModel() {
    this.createRequestFormGroup.controls['modelId'].reset();
  }

  resetFocus(selectBox) {
    switch (selectBox) {
      case 'openSelectCarDp':
        this.openSelectCarDp = false;
        break;
      case 'openSelectYearDp':
        this.openSelectYearDp = false;
        break;
      case 'openManifactureDp':
        this.openManifactureDp = false;
    }
  }

  ToggleCars(action) {
    if (!action) {
      return;
    }
    this.userAction = action;
    switch (action) {
      case 'addnewcar':
        this.myCarId = '';
        this.createRequestFormGroup.get('manufactureId').setValidators(Validators.required);
        this.createRequestFormGroup.get('manufactureId').updateValueAndValidity();
        this.createRequestFormGroup.get('modelId').setValidators(Validators.required);
        this.createRequestFormGroup.get('modelId').updateValueAndValidity();
        this.createRequestFormGroup.get('modelYear').setValidators(Validators.required);
        this.createRequestFormGroup.get('modelYear').updateValueAndValidity();
        this.createRequestFormGroup.get('vinNumber').setValidators([Validators.required, vinValidator(this.vvs)]);
        this.createRequestFormGroup.get('vinNumber').updateValueAndValidity();
        break;
      case 'chosemycars':
        this.createRequestFormGroup.controls['manufactureId'].reset();
        this.createRequestFormGroup.controls['modelId'].reset();
        this.createRequestFormGroup.controls['modelYear'].reset();
        this.createRequestFormGroup.controls['vinNumber'].reset();
        this.createRequestFormGroup.get('manufactureId').clearValidators();
        this.createRequestFormGroup.get('manufactureId').updateValueAndValidity();
        this.createRequestFormGroup.get('modelId').clearValidators();
        this.createRequestFormGroup.get('modelId').updateValueAndValidity();
        this.createRequestFormGroup.get('modelYear').clearValidators();
        this.createRequestFormGroup.get('modelYear').updateValueAndValidity();
        break;
    }
  }

  getUserWallet() {
    this.paymentService.customerWalletView().subscribe((response: any) => {
      if (response && response.case === 1) {
        this.userWallet = response.wallet;
      }
    });
  }

  getCoreCars() {
    this.cs.getManufactures('order', this.queryOptions.records, this.queryOptions.pageNumber, { isDeleted: false }).subscribe(
      (data:any) => {
        this.manifictureItems = data.manufs;
        if (this.manufactureId) {
          this.createRequestFormGroup.get('manufactureId').setValue(this.manufactureId);
        }
      },
      () => { }
    );
  }

  openCustomPopup() {
    this.togglePopup = true;
    this.document.body.style.overflow = 'hidden';
  }

  closeCustomPopup() {
    this.togglePopup = false;
    this.document.body.style.overflow = 'initial';
  }

  listUserCars() {
    this.ccs
      .listCars(this.queryOptions.sortBy, this.queryOptions.records, this.queryOptions.pageNumber, { isDeleted: false })
      .subscribe((response: any) => {
        if (response.case === 1) {
          this.userCarsList = response.cars;
          this.userCarsItems = response.cars.map(car => ({
            _id: car._id,
            nameArabic: `${car.manufactureId.nameArabic}, ${car.modelId.nameArabic}, ${car.modelYear}`,
            hasVinInfo: car.vinPhoto || car.vinNumber,
            premiumAmountPerNewPart: car.manufactureId.premiumAmountPerNewPart,
            premiumAmountPerUsedPart: car.manufactureId.premiumAmountPerUsedPart,
            premiumNewPrice: car.manufactureId.premiumNewPrice,
            premiumUsedPrice: car.manufactureId.premiumUsedPrice,
            publishCatalog: car.manufactureId.publishCatalog
          }));
        }
      });
  }

  validateCarInfo() {
    const partType = this.createRequestFormGroup.get('partType').value;
    this.myCarObject = this.userCarsList.find(c => c._id === this.myCarId);
    if (this.myCarId && partType && partType.id === 'new') {
      const selectedCar = this.userCarsItems.find(c => c._id === this.myCarId);
      if (!selectedCar) {
        return false;
      }
      if (!selectedCar.hasVinInfo) {
        return true;
      }
    }
    return false;
  }

  submitLabel() {
    if (this.isSending) {
      return 'جاري إرسال الطلب';
    }
    if (this.userProfile && this.userProfile.totalPaid < 15000 && (!this.codeResponse || this.codeResponse.case !== 1)) {
      return 'اتمام الدفع';
    } else {
      return 'إرسال الطلب';
    }
  }

  sendOrPayLabel() {
    const payingUser = this.userProfile && this.userProfile.totalPaid < 5000;
    const noResponse = !this.codeResponse || this.codeResponse.case !== 1;
    if (!this.totalPricingFee()) {
      return 'إرسال الطلب';
    }
    if (payingUser && noResponse) {
      return 'اتمام الدفع';
    } else {
      return 'إرسال الطلب';
    }
  }

  toggleModal(): void {
    this.requestSent.open = !this.requestSent.open;
  }

  setStep(isAuthenticated: boolean = false, number: number) {
    if (isAuthenticated) {
      this.getUserProfile();
      this.isAuthenticated = true;
    }
    const { partType } = this.createRequestFormGroup.value;
    if (!this.isCarSelected() && !partType) {
      return;
    }
    this.currentStep = number;
    this.steps.forEach((step, index) => {
      if (number >= index) {
        step.active = true;
      }
      if (number < index) {
        step.active = false;
      }
    });
    switch (number) {
      case 2:
        this.scs.updateAnalytics('pq_popup');
        if (this.validVINEnteredForCatalog) {
          this.scs.updateAnalytics('pq_view');
        }
        this.document.body.style.overflow = 'initial';
        break;
      case 4:
        this.scs.updateAnalytics('viewed_pq_summery');
        break;
      case 5:
        this.scs.updateAnalytics('pq_payment_initiated');
        break;
    }
    this.steps[3].active = this.isAuthenticated ? true : false;
    this.steps[3].hidden = this.isAuthenticated ? true : false;
  }

  isCarSelected(): boolean {
    if (this.myCarId) {
      this.userCarsItems.map(userCars => {
        if (userCars._id === this.myCarId) {
          this.selectedCar = userCars;
        }
      });
    }
    const validVin = this.createRequestFormGroup.get('vinNumber').valid;

    if (this.userAction === 'chosemycars' && validVin && this.myCarId && !this.validateCarInfo()) {
      return true;
    }
    if (this.userAction === 'chosemycars' && validVin && this.myCarId && this.vinNumberAdded) {
      return true;
    }

    const manufactureId = this.createRequestFormGroup.get('manufactureId').value;
    const modelId = this.createRequestFormGroup.get('modelId').value;
    const modelYear = this.createRequestFormGroup.get('modelYear').value;
    if (manufactureId && modelId && modelYear) {
      return true;
    }
    return false;
  }

  uploadImage(fileInput: any, controlName: string, partIndex = null) {
    this.uploadingPhoto = true;
    const input = fileInput.target;
    const { files } = input;
    if (input && files) {
      const fileValues = Object.keys(files).map(key => files[key]);
      if (fileValues.length) {
        fileValues.map((file: any) => {
          const fileType = file.type;
          const ValidImageTypes = ['image/gif', 'image/jpeg', 'image/png', 'image/tiff'];
          if (ValidImageTypes.indexOf(fileType) > -1) {
            this.s3Uploader.getS3Object(file).subscribe(
              res => {
                this.s3Uploader.postS3Object(res).subscribe(
                  resp => {
                    if (resp.success) {
                      const photo = resp.key;
                      if (partIndex !== null) {
                        (this.createRequestFormGroup.get('parts') as UntypedFormArray)
                          .at(partIndex)
                          .get(controlName)
                          .setValue(photo);
                      } else {
                        this.createRequestFormGroup.get(controlName).setValue(resp.key);
                        this.createRequestFormGroup.get('vinNumber').clearValidators();
                        this.createRequestFormGroup.get('vinNumber').updateValueAndValidity();
                      }
                      this.uploadingPhoto = false;
                    }
                  },
                  err => {
                    this.uploadingPhoto = false;
                  }
                );
              },
              err => {
                this.uploadingPhoto = false;
              }
            );
          } else {
            this.uploadingPhoto = false;
          }
        });
      }
    }
  }

  getPhotoUrl(name, path = '', index?) {
    let photoPath = null;
    let photoValue = null;

    switch (path) {
      case 'parts':
        photoPath = (this.createRequestFormGroup.get(path) as UntypedFormArray).at(index).get(name);
        break;
      default:
        photoPath = this.createRequestFormGroup.get(name);
        break;
    }
    try {
      photoValue = photoPath.value;
      if (photoValue?.length) {
        photoValue = `https://autotash.s3.amazonaws.com/customers/${photoValue[0]}`;
      }
    } catch (e) { }

    return photoValue;
  }

  addAnotherPart() {
    const partsArray = this.createRequestFormGroup.get('parts') as UntypedFormArray;
    if (partsArray.invalid) {
      return;
    }
    const newPart = new UntypedFormGroup({
      name: new UntypedFormControl('', {
        validators: Validators.required,
        updateOn: 'blur'
      }),
      quantity: new UntypedFormControl(1, {
        validators: Validators.required,
        updateOn: 'blur'
      }),
      photo: new UntypedFormControl()
    });
    partsArray.push(newPart);
  }

  removePart(index) {
    const partsArray = this.createRequestFormGroup.get('parts') as UntypedFormArray;
    partsArray.removeAt(index);
  }

  removeAll() {
    const partsArray = this.createRequestFormGroup.get('parts') as UntypedFormArray;
    partsArray.value.forEach((part, i) => {
      partsArray.removeAt(i);
    });
  }

  getParts() {
    return this.createRequestFormGroup.get('parts')['controls'];
  }

  async fetchCarData(car) {
    if (car) {
      await this.manufChanged(car.resp.modelId.manufactureId._id, car);
    }
  }

  getMyCarObject() {
    const manufactureId = this.createRequestFormGroup.get('manufactureId').value;
    const modelId = this.createRequestFormGroup.get('modelId').value;
    const modelYear = this.createRequestFormGroup.get('modelYear').value;

    const manufactureName = this.manifictureItems.find(m => m._id === manufactureId);
    const modelName = this.modelItems.find(m => m._id === modelId);
    if (manufactureName && modelName) {
      return `${manufactureName.nameArabic} ${modelName.nameArabic} ${modelYear}`;
    }
    return '';
  }

  submitPayment() {
    if (!this.method) {
      return;
    }
    switch (this.method) {
      case 'mada':
      case 'creditcard':
        rudderanalytics.track('Payments', {
          event_category: 'Payments',
          event_action: 'CreditPaymentStarted',
          event_label: 'PaymentsMethods'
        }, {
          integrations: {
            FacebookPixel: false
          }
        });
        break;
    }
  }

  updateAnalyticsConversion(url?) {
    const callback = () => {
      if (typeof url !== 'undefined') {
        window.location = url;
      }
    };

    this.scs.updateAnalytics('conversion', {
      send_to: 'AW-999397758/peHYCKS5qLABEP6yxtwD',
      value: this.totalPricingFee(),
      currency: 'SAR',
      transaction_id: this.request?._id,
      event_callback: callback
    });

    return false;
  }

  redirectToCatalog() {
    const modelName = encodeURIComponent(this.targetCar.modelName)
      .replace(/\-/g, '%2D')
      .replace(/\_/g, '%5F')
      .replace(/\./g, '%2E')
      .replace(/\!/g, '%21')
      .replace(/\~/g, '%7E')
      .replace(/\*/g, '%2A')
      .replace(/\'/g, '%27')
      .replace(/\(/g, '%28')
      .replace(/\)/g, '%29');
    this.scs.updateAnalytics('catalog_view');
    this.goToVINCatalog(
      `/parts/catalog/list/${this.targetCar.catalogId},${modelName},${this.targetCar.year}/${this.targetCar.carId}`,
      {
        modelId: this.targetCar.modelId,
        internalModelId: this.targetCar.internalModelId,
        manufactureId: this.targetCar.manufactureId,
        criteria: this.targetCar.criteria,
        vinNumber: this.targetCar.vinNumber
      },
      this.targetCar
    );
  }

  goToVINCatalog(route, params, data) {
    const urlParam = [];
    for (const i in params) {
      if (i) {
        urlParam.push(`${encodeURI(i)}=${encodeURI(params[i])}`);
      }
    }
    window.location.href = `${globals.appURL + route}?${urlParam.join('&')}`;
  }

  loadCatalogModelYears() {
    if (!this._selectedModel.catalogId || !this._selectedModel.id || !this.selectedCar.publishCatalog) {
      return;
    }
    const queries = {
      catalogId: this._selectedModel.catalogId,
      modelId: this._selectedModel.id
    };
    this.ccss
      .FilterModelDetails(queries)
      .pipe(take(1))
      .subscribe(
        (response:any) => {
          if (response.case === 1) {
            const paramYear = response.parameters.find(item => item.key === 'year');
            this.catalogYears = paramYear ? paramYear.values : [];
            if (this.selectedCar.publishCatalog) {
              const selectedYear = this.catalogYears.find(item => Number(item.value) === Number(this.selectedCar.modelYear));
              if (selectedYear) {
                this.setModelyear(selectedYear.idx);
              }
            }
          }
        },
        err => { },
        () => {
          this.loadingCatalogData = false;
        }
      );
  }

  setModelyear(modelYear) {
    const formInput = this.createRequestFormGroup.get('modelYear');
    formInput.setValue(modelYear);
    return formInput;
  }

  matchingQuotation() {
    let matchingPart = null;
    const data = this.createRequestFormGroup.value;
    try {
      data.parts.map(part => {
        matchingPart = this.cartService.getMatchingQuotationByName(part.name);
      });
      const allHasName = data.parts.every(part => part.name);
      if (allHasName) {
        this.validQuotation = true;
      } else {
        this.validQuotation = false;
      }
    } catch (e) { }
    return matchingPart;
  }
  premiumQuotationHandler() {
    let modelId = null;
    let modelYear = null;
    let vinNumber = null;
    let premiumPrice = null;
    let manufactureId = null;
    let modelName = null;
    let manufactureName = null;
    const data = this.createRequestFormGroup.value;
    if (this.userAction === 'addnewcar') {
      const selectedManif = this.manifictureItems.find(item => item._id === data.manufactureId);
      const selectedModel = this.modelItems.find(m => m._id === data.modelId || m.internalModelId === data.modelId);
      modelId = data.modelId;
      modelYear = data.modelYear;
      vinNumber = data.vinNumber;
      manufactureId = data.manufactureId;
      modelName = selectedModel?.nameArabic;
      manufactureName = selectedManif?.nameArabic;
    } else {
      modelId = this.userSelectedCar?.modelId?._id;
      modelYear = this.userSelectedCar?.modelYear;
      vinNumber = this.userSelectedCar?.vinNumber;
      manufactureId = this.userSelectedCar?.manufactureId?._id;
      modelName = this.userSelectedCar?.modelId?.nameArabic;
      manufactureName = this.userSelectedCar?.manufactureId?.nameArabic;
    }
    if (!modelId) {
      return;
    }
    const getPrice = this.ccss.getPrice(modelId).subscribe((price: any) => {
      if (price.case === 1) {
        premiumPrice = price.premiumPrice.premiumAmountPerNewPart;
        if (data.parts?.length) {
          data.parts.map(part => {
            const additionalCarInformation = {
              engineSize: '',
              grade: '',
              transmissionType: '',
              fuelType: '',
              salesRegion: ''
            };
            if (data.engine) {
              additionalCarInformation.engineSize = data.engine;
            }
            if (data.grade) {
              additionalCarInformation.grade = data.grade;
            }
            if (data.sales_region) {
              additionalCarInformation.salesRegion = data.sales_region;
            }
            if (data.trans_type) {
              additionalCarInformation.transmissionType = data.trans_type;
            }
            if (data.fuel_type) {
              additionalCarInformation.fuelType = data.fuel_type;
            }
            const partObj: PremiumQuotationInterface = {
              carId: manufactureId,
              internalModelId: modelId,
              modelYear,
              otherinformation: 'N/A',
              name: part.name,
              partType: data.partType.id,
              premiumPrice,
              selectedQuantity: part.quantity,
              vinNumber,
              modelName,
              manufactureName,
              photo: part.photo,
              addedFromPage: 'e-commerce',
              additionalCarInformation
            };
            if (data.engine_capacity || data.engine_type) {
              data.engineSize = `${data.engine_capacity}  ${data.engine_type}`;
              delete data.engine_capacity;
              delete data.engine_type;
            }
            rudderanalytics.track('BrowseCatalogue', {
              event_category: 'BrowseCatalogue',
              event_action: 'BASKET_ACTIONS',
              event_label: 'PQ_ADDED'
            }, {
              integrations: {
                FacebookPixel: false
              }
            });
            this.cartService.cartUpdatedAt();
            this.scs.updateAnalytics('do_added_to_cart');
            this.cartService.addPremiumQuotationNotCatalog(partObj, 'premium quotation');
          });
        }
      }
    });
  }
  clean(obj) {
    for (const propName in obj) {
      if (obj[propName] === null || obj[propName] === '') {
        delete obj[propName];
      }
    }
    return obj;
  }

  goToCheckout() {
    window.location.href = `${globals.appURL}/spare-parts/cart/`;
  }
  changeValue(e, i) {
    if (!e) {
      return;
    }
    this.getPartsList(e.target.value, i);
  }
  private getPartsList(term: string, i: number) {
    this.dataLoading = true;
    if (this.subscribtion) {
      this.subscribtion.unsubscribe();
    }
    this.subscribtion = this.cs.coreLookup(term).subscribe((data: any) => {
      this.dataLoading = false;
      let parts = [];
      if (data.length) {
        parts = data.map(part => ({
          ...part,
          id: part._id,
          es: true,
          categoryId: part.categoryId,
          label: part.nameArabic
        }));
      }
      this.partsListArray[i] = parts;
    });
  }
}